<template>
  <div class="q_sign">
    <div class="q_text_l q_bold">登录</div>
    <div class="q_text_s q_color_gray q_mar_t10px">您好，欢迎来到招远市志愿者平台</div>
    <div class="q_mar_t40px">
      <van-field v-model="phone" clearable type="tel" placeholder="请输入手机号"/>
      <van-field v-model="password" clearable :type="passwordType" class="q_mar_t15px" placeholder="请输入密码">
        <template slot="right-icon">
                      <span @click="switchPasswordType">
                           <van-icon name="closed-eye" v-if="passwordType==='password'"/>
                           <van-icon name="eye" v-else />
                      </span>
        </template>
      </van-field>
    </div>
    <div class="q_mar_t15px q_text_s">
      <span @click="goToSetpassword()">忘记密码？</span>
      <span class="q_flo_right q_color_default" @click="goToRegister()">去注册</span>
      <span class="q_flo_right">没有账号？</span>
    </div>
    <div class="q_center q_mar_t80px">
      <van-button class="q_btn_sign" round color="#FF5733" :loading="buttonLoading" @click="submitLogin"
                  :disabled="buttonLoading"
                  loading-type="spinner"
                  loading-text="正在登录">登 录
      </van-button>
    </div>
    <img src="@/assets/image/sign.png" style="width: 100%;position: fixed;bottom: 0;z-index: -1;left: 0;"/>
  </div>
</template>

<script>
import {validatePhoneNumber} from "@/utils/validate";
import {Encrypt} from "@/utils/crypto";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Sign',
  props: {
    msg: String
  },
  data() {
    return {
      passwordType:'password',
      phone: '',
      password: '',
      buttonLoading: false
    }
  },
  created() {
    wxCloseShare()
  },
  methods: {
    /**
     * 登录提交
     */
    submitLogin() {
      if (!this.phone) {
        this.$modal.alert('请输入手机号')
        return
      }
      if (!validatePhoneNumber(this.phone)) {
        this.$modal.alert('手机号格式有误')
        return
      }
      if (!this.password || this.password.length < 6 || this.password.length > 20) {
        this.$modal.alert('请输入6-20位密码')
        return
      }

      this.buttonLoading = true
      //发送登录请求
      let data = {'phone': this.phone, 'password': Encrypt(this.password)}

      this.$store.dispatch("Login", data).then(() => {
        this.$modal.success("登录成功")
        this.$store.dispatch("GetInfo").then(() => {
          this.buttonLoading = false
          setTimeout(() => {
            this.$router.push({
              path: '/'
            });
          }, 1500);

        })
      }).finally(() => {
        this.buttonLoading = false
      })

    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    goToHome() {
      this.$router.push({
        path: '/'
      });
    },
    goToRegister() {
      this.$router.push({
        path: '/mine/Register'
      });
    },
    goToSetpassword() {
      this.$router.push({
        path: '/mine/Setpassword',query:{tag:'tag'}
      });
    },
  },
}
</script>
<style>
.q_btn_sign {
  width: 300px;
  height: 40px;
  box-shadow: 0 1px 4px #FF5733;
}

.q_sign {
  padding: 70px 30px 0 30px;
}

.q_sign .van-cell {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  border-radius: 22px;
}

.q_sign .van-cell::after {
  border: none;
}
</style>
